const PartyMixMass=[
    {
        id:1,
        title:"Party Mix Whiskey",
        price:"2000 грн",
        src: require('../img/partybells.png'),
        text:"Red Bull - 6шт., віскі Bell`s - 1л",
    },
    {
        id:2,
        title:"Party Mix Jagermeister",
        price:"2300 грн",
        src: require('../img/partyjager.png'),
        text:"Red Bull - 6шт., Jägermeister - 1л",
    },
    {
        id:3,
        title:"Party Mix vodka",
        price:"870 грн",
        src: require('../img/partyvodka.png'),
        text:"Red Bull - 6шт., Перша Гільдія Поважна - 0.5л",
    },
]

export default PartyMixMass;